import {ReactElement, useState} from "react";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import {DataGridPremium, GridColDef} from "@mui/x-data-grid-premium";
import {formatSwedishDateTime} from "../../components/TimeFormat";
import {useGetModelPortfolio, useSyncModelPortfolio} from "../../application/ModelPortfolioService";
import SnackbarComponent, {defaultSnackbarState, SnackbarState} from "../../components/SnackbarComponent";
import {RefreshDataFunction} from "../../components/types/RefreshDataFunction";
import {Statistics} from "../../domain/staticdata/Statistics";
import {useAutoSizeGrid} from "../../components/AutoSizeGridHook";
import { ModelPortfolio } from "../../domain/staticdata/ModelPortfolio";
import RefreshStaticComponent from "../../components/RefreshStaticComponent";

export default function ModelPortfolios(): ReactElement {
    const { data, loading, apiFunction } = useGetModelPortfolio();
    const [ snackbarState, setSnackbarState ] = useState<SnackbarState>(defaultSnackbarState);
    const syncModelPortfolio: RefreshDataFunction<Statistics> = useSyncModelPortfolio();
    const apiRef = useAutoSizeGrid<ModelPortfolio>({
        data: data,
        loading: loading,
        columns: [
            'shortName',
            'mandate',
            'changedTimestamp',
            'mpik',
            'fullName'
        ]
    })

    const initialState =
        {
            columns: {
                columnVisibilityModel: {
                    mpik: false
                },
                dimensions: {
                    shortName: { width: 170 },
                    mandate: { width: 100 },
                    changedTimestamp: { width: 300 },
                    mpik: { width: 100 },
                    fullName: { flex: 1 }
                }
            }
        }

    const columns: GridColDef[] = [
        { field: 'shortName', headerName: 'SCD ID' },
        { field: 'mandate', headerName: 'mandate' },
        { field: 'changedTimestamp', headerName: 'ChangedTimestamp', renderCell: (params) =>
                formatSwedishDateTime(params.row.changedTimestamp)
        },
        { field: 'mpik', headerName: 'SCD Key' },
        { field: 'fullName', headerName: 'Name' }
    ];

    return (
        <Container maxWidth={ false } sx={{mt: 4, mb: 4}}>
            {<Toolbar/>}
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                <Grid size={{ xs: 12, md: 10, lg: 10 }}>
                    <Title>Model Portfolios</Title>
                </Grid>
                <RefreshStaticComponent
                    refreshFunction={ syncModelPortfolio}
                    dataFunction={ apiFunction }
                    setSnackbarState={ setSnackbarState }
                />
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ height: 1000 }}>
                    <DataGridPremium
                        apiRef={apiRef}
                        initialState={initialState}
                        showToolbar
                        loading={loading}
                        rows={data}
                        columns={columns}
                        density={"compact"}
                        getRowId={(row) => row.shortName}
                    />
                </Grid>
            </Grid>
            <SnackbarComponent setState={ setSnackbarState} state={ snackbarState}/>
        </Container>
    );
}